import { Link } from "react-router-dom";
import Hero from "../components/Hero";
import React from 'react'
import { About } from "../components/About";
import { Categories } from "../components/Categories";
import { HowToPlay } from "../components/HowToPlay";
import { Mission } from "../components/Mission";
import { Footer } from "../components/Footer";
import CatchPhrase from "../components/CatchPhrase";
import Header from "../components/Header";
import { UseCases } from "../components/UseCases";
import HumanityRisingSection from "../components/HumanityRisingSection";
import HumanityRisingRibbon from "../components/HumanityRisingRibbon";
import LargerMovementSection from "../components/LargerMovementSection";
import CompanyCredibilityBlock from "../components/CompanyCredibilityBlock";
import Testimonials from "../components/Testimonials";

const Home = () => {
  return (
    <div>
      <Hero />
      <CatchPhrase/>
      <About />
      <UseCases/>
      <Testimonials/>
      <LargerMovementSection/>
      <section id="humanity-rising-section"><HumanityRisingSection /></section>
      <Categories />
      <CompanyCredibilityBlock/>
      <Mission />
      <Footer />
      <Header />
      <HumanityRisingRibbon />
    </div>
  )
}

export default Home;
